import moment from "moment/moment";

export const formatDate = (date: string, format = "MMM D, YYYY") => moment(date).format(format);
